import React from 'react';
import moment from 'moment';
import { formatDateAndTime } from '../../../function/Helper';

interface IProps {
  selectedComplaintsInfo: any;
}

const SpecificComplaintDetails = (props: IProps) => {
  const { selectedComplaintsInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      {/* Ticket ID */}
      <div className="flex justify-between items-center">
        <div className="flex gap-6">
          <label className="text-sm text-white font-bold">Complaint ID</label>
          <label className="text-sm text-white font-normal">
            {selectedComplaintsInfo.complaintId || '-'}
          </label>
        </div>
      </div>

      {/* Raised On */}
      <div className="flex gap-12">
        <label className="text-sm text-white font-bold">Raised on</label>
        <label className="text-sm text-white font-normal">
          {selectedComplaintsInfo.createdAt
            // ? moment(selectedComplaintsInfo.createdAt).local().format('L')
            ? formatDateAndTime(selectedComplaintsInfo.createdAt)
            : '-'}
        </label>
      </div>

      {/* complaint Type */}
      <div className="flex gap-[52px]">
        <label className="text-sm text-white font-bold">Category</label>
        <label className="text-sm text-white font-normal">
          {selectedComplaintsInfo.complaintType || '-'}
        </label>
      </div>

      {/* sub Complaint Type */}
      <div className="flex gap-6">
        <label className="text-sm text-white font-bold">Sub Category</label>
        <label className="text-sm text-white font-normal">
          {selectedComplaintsInfo.subComplaintType || '-'}
        </label>
      </div>

      {/* Message */}
      <div className="flex gap-[52px]">
        <label className="text-sm text-white font-bold">Message</label>
        <label className="text-sm text-white font-normal ml-1 break-all">
          {selectedComplaintsInfo.message || '-'}
        </label>
      </div>

      {/* Contact info */}
      <div className="flex gap-8">
        <label className="text-sm text-white font-bold">Contact info</label>
        <label className="text-sm text-white font-normal">
          {selectedComplaintsInfo.contact_info || '-'}
        </label>
      </div>
    </div>
  );
};

export default SpecificComplaintDetails;
